/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import { isUsOnly } from '../../../../../utils';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  getLabelWithDefaultValue,
} from '../../../../../utils/labels/labelUtilty';
import {
  ErrorLabels,
  GLOBAL_ERRORMESSAGES_LABEL,
  lblErrorMessages2270,
  lblErrorMessagesDefault,
  lblErrorMessagesTimeout,
  lblTcpCouponUsedAlready,
  lblErrorMessages2080,
  lblErrorMessages2030,
  lblErrLogonIdAlreadyExist,
  lblErrOrderNotFound,
  lblErrorMessagesTCPGC06,
  lblErrDuplicateGC,
  lblErrDuplicateCard,
  lblErrPayCardNumberInvalid,
  lblErrormessages500,
  lblErrPromotionCodeInvalid,
  lblErrMissingCmdParameter,
  lblTcpPromotionLoyaltyCouponNotInWallet,
  lblTcpPromotionLoyaltyAvailableOnlyForRegisteredUser,
  lblErrorMessagesTCPPROMOTIONNOTTRANSFERABLE,
  lblErrorMessagesTCPPROMOTIONNOTTRANSFERABLELOYALTY,
  lblErrorMessagesApplyCouponCustomerRedemptionLimit,
  lblErrorMessagesTCPPROMOTIONAVAILABLEONLYFORREGISTEREDUSER,
  lblErrUserAuthority,
  lblPaypalCCErrorUsCrossNotSupported,
  lblPaypalCCErrorCaCrossNotSupported,
  lblPaypalCcErrorCodeShippingNameUnavailable,
  lblErrorMessagesTCP02,
  lblErrorMessagesSvs20,
  lblErrInvalidPinCard,
  lblErrorMessagesCMN0409E,
  lblErrGiftcardSvs15,
  lblErrorMessagesSvs15,
  lblErrorMessagesSvs16,
  lblGCRecaptchaFailed,
  lblErrGCSvs20,
  lblPaypalCcAuthenticationUserCanc,
  lblPaypalCcGenericError,
  lblPaypalCcFailedTransTable,
  lblCardinalCommerceError,
  lblTcpMixOrderNotAcceptedNow,
  lblTcpBopisOrderNotAcceptedNow,
  lblInvalidParam,
  lblMandatoryParamNotPassed,
  lblErrBagParams,
  lblOosOrUnavailable,
  lblErrorMessagesSvs07,
  lblErrorMessagesSvs08,
  lblErrorMessagesSvs04,
  lblTcpErrorCodeCardDeclined,
  lblTcpPaymentProcessingErr,
  lblDbgApiDoPaymentBadXdate,
  lblErrTaxwareUtlGeneralCc,
  lblCodeNotApplicable,
  lblCodeNotApplicableCa,
  lblTcpPromotionPlccAvailableAdsplacecardUser,
  lblErrUsZipcodeInvalid,
  lblErrTaxwareUtlRc,
  lblErrorMessagesTcp06,
  lblErrorMessagesTcp07,
  lblInternalServerError,
  lblErrInternalServerError,
  lblErrorMessagesCWXFR0230E,
  lblDomHistoryErrorDetected,
  lblErrRdnAlreadyExist,
  lblAssociateIdNotExist,
  lblAssociateIdDoesNotExist,
  lblAssociateIdNotValid,
  lblAssociateIdNotExistForUser,
  lblInvalidCurrentPwd,
  lblErrMaxLimitReached,
  lblInvalidPrescreenCode,
  lblMyAccountPointsClaim2,
  lblMyAccountPointsClaim3,
  lblMyAccountPointsClaim4,
  lblSystemNotAvailable,
  lblErrOrdEmailMismatch,
  lblErrorMessagesTCPBPO01,
  lblBopisNotAvailable,
  lblNoStoresFound,
  lblErrSomethingWrong,
  lblErrorOccured,
  lblErrGiftListNameTooLong,
  lblErrMoreThan300Total,
  lblErrItemCatelogEntryNotFound,
  lblErrorMessagesOobError,
  lblWicRtpsCouponNotApplied,
  lblRtpsInactivePayment,
  lblCvvRequestFailedWithCvvError,
  lblErrCredentialsExpired,
  lblCvvRequestFailedWithAuthError,
  lblInvalidRecaptcha,
  lblEmptyRecaptcha,
  lblTcpPaymentInsufficient,
  lblErrmaxItemcount,
  lblErrInvalidAddr,
  lblErrorMessagesVidesErrro1,
  lblErrorMessagesVidesErrro2,
  lblTcpPromotionCouponExpired,
  lblAppliedMobileCodeNotApplicable,
  lblMobileAppCodeNotApplicable,
  lblCouponGeneric,
  lblPromotionNotAvailableThisTime,
  lblErrMoreThan15ItemsInCart,
  lblApiCantResolveFemcenter,
  lblErrMaxShipmentsReached,
  lblApiCantResolveFfmcenterShort,
  lblErrProductItemNotFound,
  lblErrInvalidProductItem,
  lblBossInvNotApplicable,
  lblApiBadInv,
  lblApiCantResolveFfmCenterOos,
  lblApiCantResolveFfmPartialInstockMsg1,
  lblApiCantResolveFfmPartialInstockMsg2,
  lblVenmoGeneralErr,
  lblTcpAuthRequestFailedAvs,
  lblApiCartOosItem,
  lblAddressNotEligible,
  lblNoAddAvailable,
  lblProcessRequestError,
  lblTcpSflMaxLimitError,
  lblGiftCardInsufficientFund,
  lblErrResendOrderEmail,
  lblErrResendOrderNotFound,
  lblErrResendConfirmationLimitReached,
  lblErrBenefitsNotApplicable,
  lblErrStateDoesNotMatchShipmentOption,
  lblTcpPromotionCouponAlreadyUsed,
  lblTcpPromotionPlaceCashCouponExpired,
  lblTcpPromotionCouponEmptyCart,
  lblTcpEmptyCartBenefitsCoupon,
  lblErrInvalidCity,
  lblErrorOccuredTryAgain,
  lblEnterValidExpirationDate,
  lblTryLoggingInAgain,
  lblAfterpayCheckoutError,
  lblAfterpayCheckoutGcError,
  lblBopisDomInvUnavailable,
  lblUsidUnauthorized,
  lblParamCatIdBossIneligible,
  lblTcpPromotionLoyaltyNotMet,
  lblTcpPromotionPlaceCashNotMet,
  lblInsufficientInventoryCode,
  lblErrBillingAddressMissing,
  lblErrInvNotApplicable,
  lblErrShareCartItemsOos,
  lblErrShareCartGetItemsFailed,
  lblErrFailedShareCartNoId,
  lblErrFailedTriggeringUserSharecart,
  lblErrPromotionCodeValueCuplicateOnhold,
  lblApplePayCouponNotApplicable,
  lblErrBasketQuotaExceeded,
  lblErrInvalidShippingMethodId,
  lblMaxShareCartRched,
  lblPaypalAddressError,
  lblApiBadInvCheckout,
} from './Error.labels';

const getErrorList = () => {
  const errorMessages = getLabelFromCopyOrFromTranslation(GLOBAL_ERRORMESSAGES_LABEL, ErrorLabels);
  const {
    lbl_errorMessages_LOYALTY_NOT_ACTIVE: lblLoyaltyNotActive,
    lbl_errorMessages_PLACE_CASH_ERROR: lblPlaceCashError,
    lbl_errorMessage_ERR_PLCC_INELIGIBLE_PROMOTION: lblErrIneligiblePromotion,
    lbl_errorMessages_ERR_INTERNATIONAL_BILLING_ADDRESS_PLCC: lblErrBillingAddressInternationalPlcc,
    lbl_errorMessages_ERR_ADD_EDIT_CREDIT_CARD: lblErrAddEditCreditCard,
    lbl_errorMessages_ERR_INVALID_SHIPPING_METHOD_ID: lblErrInvalidShippingMethodIdMsg,
    lbl_errorMessage_ERR_PRODUCT_SHIPPING_RESTRICTED: lblErrProductShippingRestricted,
    lbl_coupon_error_TCP_PROMOTION_NOT_STACKABLE: lblCouponErrorNotStackable,
    lbl_coupon_error_ERR_COUPONS_PARTIALLY_APPLIED: lblCouponErrorPartiallyApplied,
    lbl_coupon_error_TCP_PROMOTION_REDEMPTION_REACHED: lblCouponErrorRedemtionReached,
    lbl_coupon_error_TCP_PROMOTION_THRESHOLD_NOT_MET: lblCouponErrorThresholdNotMet,
    lbl_coupon_error_TCP_PROMOTION_COUPON_ALREADY_USED_CUSTOM_MULTI:
      lblCouponErrorCouponAlreadyUsedCustomMulti,
    lbl_errorMessages_ERR_PROMOTION_NOT_AVAILABLE_AT_THIS_TIME_CUSTOM_MULTI:
      lblErrPromotionNotAvailableAtThisTimeCustomMulti,
    lbl_coupon_error_TCP_PROMOTION_COUPON_EXPIRED_CUSTOM_MULTI:
      lblCouponErrorCouponExpiredCustomMulti,
    lbl_errorMessages_ERR_ADYEN_MIX_PAYMENT_NOT_ALLOWED: lblErrAdyenMixPaymentNotAllowed,
    lbl_errorMessages_ERR_CROSS_SITE_ADDRESS_NOT_SUPPORTED: lblErrAdyenCrossSiteAddressNotSupported,
    lbl_errorMessages_ERR_SHIPPING_ADDRESS_MISSING: lblErrAdyenShippingAddressMissing,
    lbl_errorMessages_ERR_INVALID_ZIPCODE: lblErrAdyenInvalidZipcode,

    lbl_errorMessages_ERR_INVALID_SHIPPING_METHOD: lblErrInvalidShippingMethod,
  } = getDynamicLabelValues('dynamic.error_messages');
  const paymentGcLabels = getDynamicLabelValues('dynamic.account_d');
  return {
    _TCP_COUPON_USED_ALREADY: getLabelWithDefaultValue(errorMessages, lblTcpCouponUsedAlready),
    CWXFR0221E: getLabelWithDefaultValue(errorMessages, lblErrorMessagesDefault),
    TIMEOUT_ERROR: getLabelWithDefaultValue(errorMessages, lblErrorMessagesTimeout),
    _2270: getLabelWithDefaultValue(errorMessages, lblErrorMessages2270),
    _2080: getLabelWithDefaultValue(errorMessages, lblErrorMessages2080),
    _2030: getLabelWithDefaultValue(errorMessages, lblErrorMessages2030),
    _ERR_LOGONID_ALREDY_EXIST: getLabelWithDefaultValue(errorMessages, lblErrLogonIdAlreadyExist),
    ERR_ORDER_NOT_FOUND: getLabelWithDefaultValue(errorMessages, lblErrOrderNotFound),
    TCPGC06: getLabelWithDefaultValue(errorMessages, lblErrorMessagesTCPGC06),
    _ERR_DUPLICATE_GIFT_CARD: getLabelWithDefaultValue(errorMessages, lblErrDuplicateGC),
    _ERR_DUPLICATE_CARD: getLabelWithDefaultValue(errorMessages, lblErrDuplicateCard),
    _ERR_PAY_CARD_NUMBER_INVALID: getLabelWithDefaultValue(
      errorMessages,
      lblErrPayCardNumberInvalid
    ),
    _500: getLabelWithDefaultValue(errorMessages, lblErrormessages500),
    ERR_PROMOTION_CODE_INVALID: getLabelWithDefaultValue(errorMessages, lblErrPromotionCodeInvalid),
    _ERR_MISSING_CMD_PARAMETER: getLabelWithDefaultValue(errorMessages, lblErrMissingCmdParameter),
    _TCP_PROMOTION_LOYALTY_COUPON_NOT_IN_WALLET: getLabelWithDefaultValue(
      errorMessages,
      lblTcpPromotionLoyaltyCouponNotInWallet
    ),
    _TCP_PROMOTION_LOYALTY_AVAILABE_ONLY_FOR_REGISTERED_USER: getLabelWithDefaultValue(
      errorMessages,
      lblTcpPromotionLoyaltyAvailableOnlyForRegisteredUser
    ),
    TCP_PROMOTION_LOYALTY_NOT_TRANSFERABLE: getLabelWithDefaultValue(
      errorMessages,
      lblErrorMessagesTCPPROMOTIONNOTTRANSFERABLE
    ),
    TCP_PROMOTION_NOT_TRANSFERABLE: getLabelWithDefaultValue(
      errorMessages,
      lblErrorMessagesTCPPROMOTIONNOTTRANSFERABLE
    ),
    TCP_PROMOTION_NOT_TRANSFERABLE_LOYALTY: getLabelWithDefaultValue(
      errorMessages,
      lblErrorMessagesTCPPROMOTIONNOTTRANSFERABLELOYALTY
    ),
    _ERR_APPLY_COUPON_CUSTOMER_REDEMPTION_LIMIT: getLabelWithDefaultValue(
      errorMessages,
      lblErrorMessagesApplyCouponCustomerRedemptionLimit
    ),
    TCP_PROMOTION_AVAILABLE_ONLY_FOR_REGISTERED_USER: getLabelWithDefaultValue(
      errorMessages,
      lblErrorMessagesTCPPROMOTIONAVAILABLEONLYFORREGISTEREDUSER
    ),
    _ERR_USER_AUTHORITY: getLabelWithDefaultValue(errorMessages, lblErrUserAuthority),
    PAYPAL_CC_ERROR_CODE_US_CROSS_SITE_ADDRESS_NOT_SUPPORTED: getLabelWithDefaultValue(
      errorMessages,
      lblPaypalCCErrorUsCrossNotSupported
    ),
    PAYPAL_CC_ERROR_CODE_CANADA_CROSS_SITE_ADDRESS_NOT_SUPPORTED: getLabelWithDefaultValue(
      errorMessages,
      lblPaypalCCErrorCaCrossNotSupported
    ),
    PAYPAL_CC_ERROR_CODE_SHIPPING_LASTNAME_OR_FIRSTNAME_NOT_AVAILABLE_IN_PAYPAL_ACCOUNT:
      getLabelWithDefaultValue(errorMessages, lblPaypalCcErrorCodeShippingNameUnavailable),
    PAYPAL_CC_ERROR_CODE_BILLING_LASTNAME_OR_FIRSTNAME_NOT_AVAILABLE_IN_PAYPAL_ACCOUNT:
      getLabelWithDefaultValue(errorMessages, lblPaypalCcErrorCodeShippingNameUnavailable),
    TCP02: getLabelWithDefaultValue(errorMessages, lblErrorMessagesTCP02),
    SVS20: getLabelWithDefaultValue(errorMessages, lblErrorMessagesSvs20),
    _ERR_INVALID_PIN_CARD: getLabelWithDefaultValue(errorMessages, lblErrInvalidPinCard),
    CMN0409E: getLabelWithDefaultValue(errorMessages, lblErrorMessagesCMN0409E),
    _ERR_GIFTCARD_SVS15: getLabelWithDefaultValue(errorMessages, lblErrGiftcardSvs15),
    SVS15: getLabelWithDefaultValue(errorMessages, lblErrorMessagesSvs15),
    SVS16: getLabelWithDefaultValue(errorMessages, lblErrorMessagesSvs16),
    GIFT_CARD_RECAPTCHA_FAILED: getLabelWithDefaultValue(errorMessages, lblGCRecaptchaFailed),
    _ERR_GIFTCARD_SVS20: getLabelWithDefaultValue(errorMessages, lblErrGCSvs20),
    PAYPAL_CC_ERROR_CODE_AUTHENTICATION_USER_CANCELED: getLabelWithDefaultValue(
      errorMessages,
      lblPaypalCcAuthenticationUserCanc
    ),
    PAYPAL_CC_ERROR_CODE_GENERIC_ERROR: getLabelWithDefaultValue(
      errorMessages,
      lblPaypalCcGenericError
    ),
    PAYPAL_CC_ERROR_CODE_FAILED_UPDATE_PAYPAL_TRANS_TABLE: getLabelWithDefaultValue(
      errorMessages,
      lblPaypalCcFailedTransTable
    ),
    PAYPAL_CC_ERROR_CODE_CARDINAL_COMMERCE_ERROR: getLabelWithDefaultValue(
      errorMessages,
      lblCardinalCommerceError
    ),
    TCP_MIX_ORDER_NOT_ACCEPTED_NOW: getLabelWithDefaultValue(
      errorMessages,
      lblTcpMixOrderNotAcceptedNow
    ),
    _TCP_BOPIS_ORDER_NOT_ACCEPTED_NOW: getLabelWithDefaultValue(
      errorMessages,
      lblTcpBopisOrderNotAcceptedNow
    ),
    INVALID_PARAM: getLabelWithDefaultValue(errorMessages, lblInvalidParam),
    MANDATORY_PARAM_NOT_PASSED: getLabelWithDefaultValue(errorMessages, lblMandatoryParamNotPassed),
    _ERR_BAD_PARMS: getLabelWithDefaultValue(errorMessages, lblErrBagParams),
    OOS_OR_UNAVAILABLE: getLabelWithDefaultValue(errorMessages, lblOosOrUnavailable),
    SVS07: getLabelWithDefaultValue(errorMessages, lblErrorMessagesSvs07),
    SVS08: getLabelWithDefaultValue(errorMessages, lblErrorMessagesSvs08),
    SVS04: getLabelWithDefaultValue(errorMessages, lblErrorMessagesSvs04),
    TCP_ERROR_CODE_CARD_DECLINED: getLabelWithDefaultValue(
      errorMessages,
      lblTcpErrorCodeCardDeclined
    ),
    DEFAULT: getLabelWithDefaultValue(errorMessages, lblErrorMessagesDefault),
    _TCP_PAYMENT_PROCESSING_ERR: getLabelWithDefaultValue(
      errorMessages,
      lblTcpPaymentProcessingErr
    ),
    _DBG_API_DO_PAYMENT_BAD_XDATE: getLabelWithDefaultValue(
      errorMessages,
      lblDbgApiDoPaymentBadXdate
    ),
    ERR_TAXWARE_UTL_GENERAL_CC: getLabelWithDefaultValue(errorMessages, lblErrTaxwareUtlGeneralCc),
    _CODE_NOT_APPLICABLE: getLabelWithDefaultValue(
      errorMessages,
      isUsOnly() ? lblCodeNotApplicable : lblCodeNotApplicableCa
    ),
    _TCP_PROMOTION_PLCC_AVAILABE_ONLY_FOR_ADSPLACECARD_USER: getLabelWithDefaultValue(
      errorMessages,
      lblTcpPromotionPlccAvailableAdsplacecardUser
    ),
    _ERR_US_ZIPCODE_INVALID: getLabelWithDefaultValue(errorMessages, lblErrUsZipcodeInvalid),
    ERR_TAXWARE_UTL_RC: getLabelWithDefaultValue(errorMessages, lblErrTaxwareUtlRc),
    TCP06: getLabelWithDefaultValue(errorMessages, lblErrorMessagesTcp06),
    TCP07: getLabelWithDefaultValue(errorMessages, lblErrorMessagesTcp07),
    INTERNAL_SERVER_ERROR: getLabelWithDefaultValue(errorMessages, lblInternalServerError),
    ERR_INTERNAL_SERVER_ERROR: getLabelWithDefaultValue(errorMessages, lblErrInternalServerError),
    CWXFR0230E: getLabelWithDefaultValue(errorMessages, lblErrorMessagesCWXFR0230E),
    DOM_HISTORY_ERROR_DETECTED: getLabelWithDefaultValue(errorMessages, lblDomHistoryErrorDetected),
    _ERR_RDN_ALREADY_EXIST: getLabelWithDefaultValue(errorMessages, lblErrRdnAlreadyExist),
    ASSOCIATE_ID_NOT_EXIST: getLabelWithDefaultValue(errorMessages, lblAssociateIdNotExist),
    ASSOCIATE_ID_DOES_NOT_EXIST: getLabelWithDefaultValue(
      errorMessages,
      lblAssociateIdDoesNotExist
    ),
    ASSOCIATE_ID_NOT_VALID: getLabelWithDefaultValue(errorMessages, lblAssociateIdNotValid),
    ASSOCIATE_ID_NOT_EXIST_FOR_THE_USER: getLabelWithDefaultValue(
      errorMessages,
      lblAssociateIdNotExistForUser
    ),
    INVALID_CURRENT_PASSWORD: getLabelWithDefaultValue(errorMessages, lblInvalidCurrentPwd),
    _ERR_MAX_LIMIT_REACHED: getLabelWithDefaultValue(errorMessages, lblErrMaxLimitReached),
    INVALID_PRESCREEN_CODE: getLabelWithDefaultValue(errorMessages, lblInvalidPrescreenCode),
    MY_ACCOUNT_POINTS_CLAIM_2: getLabelWithDefaultValue(errorMessages, lblMyAccountPointsClaim2),
    MY_ACCOUNT_POINTS_CLAIM_3: getLabelWithDefaultValue(errorMessages, lblMyAccountPointsClaim3),
    MY_ACCOUNT_POINTS_CLAIM_4: getLabelWithDefaultValue(errorMessages, lblMyAccountPointsClaim4),
    ERR_DUPLICATE_CARD: getLabelWithDefaultValue(errorMessages, lblErrDuplicateCard),
    ERR_SYSTEM_NOT_AVAILABLE: getLabelWithDefaultValue(errorMessages, lblSystemNotAvailable),
    ERR_ORD_EMAIL_MISMATCH: getLabelWithDefaultValue(errorMessages, lblErrOrdEmailMismatch),
    TCPBPO01: getLabelWithDefaultValue(errorMessages, lblErrorMessagesTCPBPO01),
    BOPIS_NOT_AVAILABLE: getLabelWithDefaultValue(errorMessages, lblBopisNotAvailable),
    NO_STORES_FOUND: getLabelWithDefaultValue(errorMessages, lblNoStoresFound),
    ERR_SOMETHING_WRONG: getLabelWithDefaultValue(errorMessages, lblErrSomethingWrong),
    _ERROR_OCCURED: getLabelWithDefaultValue(errorMessages, lblErrorOccured),
    _ERR_GIFTLIST_NAME_TOO_LONG: getLabelWithDefaultValue(errorMessages, lblErrGiftListNameTooLong),
    _ERR_MORE_THAN_300_TOTAL_IN_CART_ERROR: getLabelWithDefaultValue(
      errorMessages,
      lblErrMoreThan300Total
    ),
    _ERR_GIFTLIST_ITEM_CATALOGENTRY_NOT_FOUND: getLabelWithDefaultValue(
      errorMessages,
      lblErrItemCatelogEntryNotFound
    ),
    OOB_ERROR: getLabelWithDefaultValue(errorMessages, lblErrorMessagesOobError),
    _WIC_RTPS_COUPON_NOT_APPLIED: getLabelWithDefaultValue(
      errorMessages,
      lblWicRtpsCouponNotApplied
    ),
    _RTPS_INACTIVE_PAYMENT: getLabelWithDefaultValue(errorMessages, lblRtpsInactivePayment),
    _TCP_CVV_REQUEST_FAILED_WITH_CREDIT_CARD_CVV_ERROR: getLabelWithDefaultValue(
      errorMessages,
      lblCvvRequestFailedWithCvvError
    ),
    _ERR_CREDENTIALS_EXPIRED: getLabelWithDefaultValue(errorMessages, lblErrCredentialsExpired),
    _TCP_CVV_REQUEST_FAILED_WITH_CREDIT_CARD_AUTH_ERROR: getLabelWithDefaultValue(
      errorMessages,
      lblCvvRequestFailedWithAuthError
    ),
    INVALID_RECAPTCHA: getLabelWithDefaultValue(errorMessages, lblInvalidRecaptcha),
    EMPTY_RECAPTCHA: getLabelWithDefaultValue(errorMessages, lblEmptyRecaptcha),
    _TCP_PAYMENT_INSUFFICIENT: getLabelWithDefaultValue(errorMessages, lblTcpPaymentInsufficient),
    LOYALTY_NOT_ACTIVE: lblLoyaltyNotActive,
    ERR_MAX_ITEMCOUNT: getLabelWithDefaultValue(errorMessages, lblErrmaxItemcount),
    _ERR_INVALID_ADDR: getLabelWithDefaultValue(errorMessages, lblErrInvalidAddr),
    VIDES_ERRRO_1: getLabelWithDefaultValue(errorMessages, lblErrorMessagesVidesErrro1),
    VIDES_ERRRO_2: getLabelWithDefaultValue(errorMessages, lblErrorMessagesVidesErrro2),
    _TCP_PROMOTION_COUPON_EXPIRED: getLabelWithDefaultValue(
      errorMessages,
      lblTcpPromotionCouponExpired
    ),
    _APPLIED_MOBILE_CODE_NOT_APPLICABLE: getLabelWithDefaultValue(
      errorMessages,
      lblAppliedMobileCodeNotApplicable
    ),
    _MOBILE_APP_CODE_NOT_APPLICABLE: getLabelWithDefaultValue(
      errorMessages,
      lblMobileAppCodeNotApplicable
    ),
    COUPON_GENERIC: getLabelWithDefaultValue(errorMessages, lblCouponGeneric),
    ERR_PROMOTION_NOT_AVAILABLE_AT_THIS_TIME: getLabelWithDefaultValue(
      errorMessages,
      lblPromotionNotAvailableThisTime
    ),
    _ERR_MORE_THAN_15_ITEM_IN_CART_ERROR: getLabelWithDefaultValue(
      errorMessages,
      lblErrMoreThan15ItemsInCart
    ),
    _API_CANT_RESOLVE_FFMCENTER: getLabelWithDefaultValue(
      errorMessages,
      lblApiCantResolveFemcenter
    ),
    _BOSS_BOPIS_QUANTITY_UNAVAILABLE: getLabelWithDefaultValue(
      errorMessages,
      lblApiCantResolveFemcenter
    ),
    _PRODUCT_QUANTITY_UNAVAILABLE: getLabelWithDefaultValue(
      errorMessages,
      lblApiCantResolveFemcenter
    ),
    _ECOM_QUANTITY_UNAVAILABLE: getLabelWithDefaultValue(errorMessages, lblApiCantResolveFemcenter),
    _ERR_MAX_SHIPMENTS_REACHED: getLabelWithDefaultValue(errorMessages, lblErrMaxShipmentsReached),
    _API_CANT_RESOLVE_FFMCENTER_SHORT: getLabelWithDefaultValue(
      errorMessages,
      lblApiCantResolveFfmcenterShort
    ),
    _ERR_PRODUCT_ITEM_NOT_FOUND: getLabelWithDefaultValue(errorMessages, lblErrProductItemNotFound),
    _ERR_INVALID_PRODUCT_ITEM: getLabelWithDefaultValue(errorMessages, lblErrInvalidProductItem),
    _BOSS_INV_NOT_AVAILABLE: getLabelWithDefaultValue(errorMessages, lblBossInvNotApplicable),
    OOS_BOSS_SWITCH_ERROR: getLabelWithDefaultValue(errorMessages, lblApiBadInv),
    _API_CANT_RESOLVE_FFMCENTER_OOS: getLabelWithDefaultValue(
      errorMessages,
      lblApiCantResolveFfmCenterOos
    ),
    _API_CANT_RESOLVE_FFMCENTER_PARTIAL_INSTOCK_MSG1: getLabelWithDefaultValue(
      errorMessages,
      lblApiCantResolveFfmPartialInstockMsg1
    ),
    _API_CANT_RESOLVE_FFMCENTER_PARTIAL_INSTOCK_MSG2: getLabelWithDefaultValue(
      errorMessages,
      lblApiCantResolveFfmPartialInstockMsg2
    ),

    _API_BAD_INV: getLabelWithDefaultValue(errorMessages, lblApiBadInv),
    CHECKOUT_API_BAD_INV: getLabelWithDefaultValue(errorMessages, lblApiBadInvCheckout),
    VENMO_GENERAL_ERROR: getLabelWithDefaultValue(errorMessages, lblVenmoGeneralErr),
    _TCP_AUTH_REQUEST_FAILED_WITH_PLCC_AVS_ERROR: getLabelWithDefaultValue(
      errorMessages,
      lblTcpAuthRequestFailedAvs
    ),
    API_CART_OOS_ITEM: getLabelWithDefaultValue(errorMessages, lblApiCartOosItem),
    ERR_ADDRESS_NOT_ELIGIBLE: getLabelWithDefaultValue(errorMessages, lblAddressNotEligible),
    ERR_NO_ADDR_AVAILABLE: getLabelWithDefaultValue(errorMessages, lblNoAddAvailable),
    ERR_REQUEST_TIMEOUT: getLabelWithDefaultValue(errorMessages, lblProcessRequestError),
    _PLACE_CASH_ERROR: lblPlaceCashError,
    TCP_SFL_MAX_LIMIT_ERROR: getLabelWithDefaultValue(errorMessages, lblTcpSflMaxLimitError),
    _ERR_INSUFFICIENT_FUND: getLabelWithDefaultValue(errorMessages, lblGiftCardInsufficientFund),
    ERR_RESEND_ORDER_EMAIL: getLabelWithDefaultValue(errorMessages, lblErrResendOrderEmail),
    ERR_RESEND_ORDER_DETAIL_NOT_FOUND: getLabelWithDefaultValue(
      errorMessages,
      lblErrResendOrderNotFound
    ),
    ERR_RESEND_CONFIRMATION_LIMIT_REACHED: getLabelWithDefaultValue(
      errorMessages,
      lblErrResendConfirmationLimitReached
    ),
    ERR_BENEFITS_NOT_APPLICABLE: getLabelWithDefaultValue(
      errorMessages,
      lblErrBenefitsNotApplicable
    ),
    _ERR_STATE_DOES_NOT_MATCH_SHIPMENT_OPTION: getLabelWithDefaultValue(
      errorMessages,
      lblErrStateDoesNotMatchShipmentOption
    ),
    _TCP_PROMOTION_COUPON_ALREADY_USED: getLabelWithDefaultValue(
      errorMessages,
      lblTcpPromotionCouponAlreadyUsed
    ),
    _TCP_PROMOTION_PLACE_CASH_COUPON_EXPIRED: getLabelWithDefaultValue(
      errorMessages,
      lblTcpPromotionPlaceCashCouponExpired
    ),
    TCP_PROMOTION_COUPON_ON_EMPTY_CART: getLabelWithDefaultValue(
      errorMessages,
      lblTcpPromotionCouponEmptyCart
    ),
    TCP_BENEFITS_COUPON_ON_EMPTY_CART: getLabelWithDefaultValue(
      errorMessages,
      lblTcpEmptyCartBenefitsCoupon
    ),
    ERR_INVALID_CITY: getLabelWithDefaultValue(errorMessages, lblErrInvalidCity),
    AN_ERROR_OCCURRED_PLEASE_TRY_AGAIN: getLabelWithDefaultValue(
      errorMessages,
      lblErrorOccuredTryAgain
    ),
    PLEASE_ENTER_A_VALID_EXPIRATION_DATE: getLabelWithDefaultValue(
      errorMessages,
      lblEnterValidExpirationDate
    ),
    TRY_LOGGING_OUT_AND_LOG_BACK_IN_OR_TRY_AGAIN_LATER: getLabelWithDefaultValue(
      errorMessages,
      lblTryLoggingInAgain
    ),
    AFTERPAY_CHECKOUT_ERROR: getLabelWithDefaultValue(errorMessages, lblAfterpayCheckoutError),
    _ERR_PAYPAL_LOOKUP_INVALID_SHIPPING_ADDERSS: getLabelWithDefaultValue(
      errorMessages,
      lblPaypalAddressError
    ),
    AFTERPAY_CHECKOUT_GC_ERROR: getLabelWithDefaultValue(errorMessages, lblAfterpayCheckoutGcError),
    BOPIS_DOM_INVENTORY_UNAVAILABLE: getLabelWithDefaultValue(
      errorMessages,
      lblBopisDomInvUnavailable
    ),
    USID_UNAUTHORIZED: getLabelWithDefaultValue(errorMessages, lblUsidUnauthorized),
    PARAM_catEntryId_BOSS_INELIGIBLE: getLabelWithDefaultValue(
      errorMessages,
      lblParamCatIdBossIneligible
    ),
    TCP_PROMOTION_LOYALTY_THRESHOLD_NOT_MET: getLabelWithDefaultValue(
      errorMessages,
      lblTcpPromotionLoyaltyNotMet
    ),
    TCP_PROMOTION_PLACECASH_THRESHOLD_NOT_MET: getLabelWithDefaultValue(
      errorMessages,
      lblTcpPromotionPlaceCashNotMet
    ),
    INSUFFICIENT_INVENTORY_CODE: getLabelWithDefaultValue(
      errorMessages,
      lblInsufficientInventoryCode
    ),
    _ERR_BILLING_ADDRESS_MISSING: getLabelWithDefaultValue(
      errorMessages,
      lblErrBillingAddressMissing
    ),
    _ERR_INVENTORY_NOT_AVAILABLE: getLabelWithDefaultValue(errorMessages, lblErrInvNotApplicable),
    _ERR_INTERNATIONAL_BILLING_ADDRESS_PLCC: lblErrBillingAddressInternationalPlcc,
    _ERR_ADD_EDIT_CREDIT_CARD: getLabelWithDefaultValue(errorMessages, lblErrAddEditCreditCard),
    _ERR_GIFTCARD_SHUTDOWN_SVS15: getLabelWithDefaultValue(
      paymentGcLabels,
      'lbl_paymentGC_error__ERR_GIFTCARD_SHUTDOWN_SVS15'
    ),
    _ERR_GIFTCARD_INVALID_MESSAGE_SVS07: getLabelWithDefaultValue(
      paymentGcLabels,
      'lbl_paymentGC_error__ERR_GIFTCARD_INVALID_MESSAGE_SVS07'
    ),
    _ERR_INVALID_SHIPPING_METHOD_ID:
      lblErrInvalidShippingMethodIdMsg ||
      getLabelWithDefaultValue(errorMessages, lblErrInvalidShippingMethodId),
    ERR_PRODUCT_SHIPPING_RESTRICTED: lblErrProductShippingRestricted,
    _ERR_BASKET_QUOTA_EXCEEDED: getLabelWithDefaultValue(errorMessages, lblErrBasketQuotaExceeded),
    APPLE_PAY_COUPON_NOT_APPLICABLE: getLabelWithDefaultValue(
      errorMessages,
      lblApplePayCouponNotApplicable
    ),
    _ERR_PROMOTION_CODE_VALUE_DUPLICATE_ONHOLD: getLabelWithDefaultValue(
      errorMessages,
      lblErrPromotionCodeValueCuplicateOnhold
    ),
    ERR_FAILED_SAVE_SHARE_CART: getLabelWithDefaultValue(
      errorMessages,
      lblErrFailedTriggeringUserSharecart
    ),
    ERR_MAX_SAVE_SHARE_CART_REACHED: getLabelWithDefaultValue(errorMessages, lblMaxShareCartRched),
    ERR_FAILED_SHARE_CART_NOREQIDFOUND: getLabelWithDefaultValue(
      errorMessages,
      lblErrFailedShareCartNoId
    ),
    ERR_SHARE_CART_GET_ITEMS_FAILED: getLabelWithDefaultValue(
      errorMessages,
      lblErrShareCartGetItemsFailed
    ),
    ERR_FAILED_SHARE_CART_NOAVAILITEMS: getLabelWithDefaultValue(
      errorMessages,
      lblErrShareCartItemsOos
    ),
    ERR_PLCC_INELIGIBLE_PROMOTION: lblErrIneligiblePromotion,
    TCP_PROMOTION_REDEMPTION_REACHED: lblCouponErrorRedemtionReached,
    TCP_PROMOTION_THRESHOLD_NOT_MET: lblCouponErrorThresholdNotMet,
    TCP_PROMOTION_NOT_STACKABLE: lblCouponErrorNotStackable,
    ERR_COUPONS_PARTIALLY_APPLIED: lblCouponErrorPartiallyApplied,
    TCP_PROMOTION_COUPON_ALREADY_USED_CUSTOM_MULTI: lblCouponErrorCouponAlreadyUsedCustomMulti,
    ERR_PROMOTION_NOT_AVAILABLE_AT_THIS_TIME_CUSTOM_MULTI:
      lblErrPromotionNotAvailableAtThisTimeCustomMulti,
    TCP_PROMOTION_COUPON_EXPIRED_CUSTOM_MULTI: lblCouponErrorCouponExpiredCustomMulti,
    ERR_ADYEN_MIX_PAYMENT_NOT_ALLOWED: lblErrAdyenMixPaymentNotAllowed,
    ERR_CROSS_SITE_ADDRESS_NOT_SUPPORTED: lblErrAdyenCrossSiteAddressNotSupported,
    _ERR_SHIPPING_ADDRESS_MISSING: lblErrAdyenShippingAddressMissing,
    _ERR_INVALID_ZIPCODE: lblErrAdyenInvalidZipcode,
    ERR_INVALID_SHIPPING_METHOD: lblErrInvalidShippingMethod,
  };
};

export default getErrorList;
